import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";

export const $AddressBookModuleName = "addressbook";

export type TAddressBookState = {
    addresses: Array<CloudCustomerAddress>;
};
